import { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import TextField from '@mui/material/TextField'
import { useSelector, useDispatch } from 'react-redux'
import { 
  clearEditDebtModalParams, 
  selectEditDebtModalParams, 
  selectShowEditDebtModal 
} from '../billingSlice'
import Content from './Content'
import { useGetSessionsByPlateNumberQuery } from '@/api/adminServiceApi'

const EditDebtModal = () => {
  const dispatch = useDispatch();
  const show = useSelector(selectShowEditDebtModal);
  const params = useSelector(selectEditDebtModalParams);
  const [inputValue, setInputValue] = useState('');
  const [queryParams, setQueryParams] = useState(null);
  const searchInputRef = useRef(null);
  const [isEditDebtLoading, setIsEditDebtLoading] = useState(false);
  const { t } = useTranslation();
  
  const onCloseHandler = () => {
    setInputValue('');
    setQueryParams(null);
    dispatch(clearEditDebtModalParams());
  }

  const { 
    isLoading: isSearchLoading,
    data: searchResponse,
    error: searchRequestError,
  } = useGetSessionsByPlateNumberQuery(queryParams, {
    skip: !queryParams?.buildingId || !queryParams?.plateNumber,
  })

  const onSearchHandler = () => {
    if (inputValue) {
      setQueryParams({
        buildingId: params?.buildingId,
        plateNumber: inputValue,
      });
    }
  }
  
  return (
    <Dialog 
      open={show}
      onClose={onCloseHandler}
    >
      <DialogTitle>{'Редактировать задолженность'}</DialogTitle>
      <DialogContent>
        <Stack direction="column" spacing={2} sx={{
          paddingTop: 2
        }}>
          {
            !searchResponse && !searchRequestError && (
              <DialogContentText>{'Введите номер автомобиля'}</DialogContentText>
            )
          }
          <Stack direction="row" spacing={2}>
            <TextField
              autoFocus
              disabled={isSearchLoading || isEditDebtLoading}
              fullWidth
              id="govNumber"
              label={t('plate_number')}
              margin="dense"
              onChange={({ target }) => {
                setInputValue(target.value)
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  onSearchHandler();
                }
              }}
              ref={searchInputRef}
              value={inputValue}
            />
            <Button 
              disabled={
                !inputValue || isSearchLoading || isEditDebtLoading
              }
              onClick={onSearchHandler}
            >
              {'Поиск'}
            </Button>
          </Stack>
          <Content
            key={queryParams} 
            queryParams={queryParams}
            onEditLoading={(value) => setIsEditDebtLoading(value)}
          />
        </Stack>
      </DialogContent>
    </Dialog>
  );
} 

export default EditDebtModal;